export const planImageActionTypes = {
  setLidGroundViewImage: "SET_LID_GROUND_VIEW_IMAGE",
  setIntermediateCeilingGroundViewImage: "SET_INTERMEDIATE_CEILING_GROUND_VIEW_IMAGE",
  setFloorGroundViewImage: "SET_FLOOR_GROUND_VIEW_IMAGE",
  setSideAElevationViewImage: "SET_SIDE_A_ELEVATION_VIEW_IMAGE",
  setSideBElevationViewImage: "SET_SIDE_B_ELEVATION_VIEW_IMAGE",
  setSideCElevationViewImage: "SET_SIDE_C_ELEVATION_VIEW_IMAGE",
  setSideDElevationViewImage: "SET_SIDE_D_ELEVATION_VIEW_IMAGE"
}
